module.exports = __webpack_public_path__ + "static/media/3_walrus.1c3580b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/3_walrus.png
// module id = 118
// module chunks = 0